<template>
  <div>
	  <Header @changePhone="changePhone"/>
	  <div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
	      <div class="banner">

  </div>
  <!--banner--> 
  
  <!--neirong-->
   <div class="bread_bg"><div class="bread"> <a href="/">首页</a> - <a href="javascript:void(0)">客户名录</a></div></div>
  <div class="neirong">
  <div class="fenlei_bg">
  <div class="fenlei_l"><b>快速检索客户</b>  <a href="javascript:void(0)" @click="selData(item.name)" :class="item.name==region?'selected0':''" v-for="item in tabList" :key="item.value">{{item.name}}</a></div>

 <div class="fenlei_r">
          <input name="" type="text"  v-model="client" placeholder="搜索智慧工会客户" class="search_txt2"/>
          <input name="" type="button"  class="search_but2" @click="search"/>

        </div>
  </div>
 <ul class="kehu_list2">
              <li data-aos="flip-left" v-for="item in list" :key="item.id"><img :src="item.image"  /></li>
            </ul>
	        <ul id="page">
	            <li><a href="javascript:void(0)" @click="goPage('home')">首页</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('last')">上一页</a></li>
	            <li v-for="index in indexs" @click="goPage(index)"><a :class="pageNum==index?'pagesel':''" href="javascript:void(0)">{{index}}</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('next')">下一页</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('end')">尾页</a></li>
	            <li class="total">共{{totalPage}}页</li>
	        </ul>
	      </div>
	    </div>
	         <Footer></Footer> 
	   
	  </div>
	  
    
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import{getDictList,getClientList} from '@/api/reqFetch.js'
  export default {
  	name: '',
    layout: '',
	components: {
	  Footer,
	  Header
	},
  	data() {
  		return {
			tabList:[],
			selName:'全部新闻',
			selid:'0',
			list:[],
			pageNum: 1,
			indexs: [],
			totalPage: 0,
			showPhone:false,
			region:'全部',
			client:''
		}
  	},

  	mounted() {
	  this.region=this.$route.query.region?this.$route.query.region:'全部'
	  this.getDictList()
	  this.getData()
  	},

  	methods: {
		changePhone(val){
			this.showPhone=val
		},
		goNext(url){
			this.$router.push({
				path:url,
			})
		},
		selData(id){
			this.region=id;
			this.search()
		},
		search(){
			this.pageNum=1;
			this.getData()
		},
		getDictList(){
			getDictList({
				dictType:'cms_client_region'
			}).then(res => {
				res.data.dictList.unshift({
					name:'全部',
					value:''
				})
				this.tabList = res.data.dictList;
			});
		},

		checkIndex() {
		    var left = 1;
		    var right = this.totalPage;
		    var ar = [];
		    if (this.totalPage >= 3) {
		        if (this.pageNum > 1 && this.pageNum < this.totalPage - 2) {
		            left = this.pageNum - 1
		            right = this.pageNum + 1
		        } else {
		            if (this.pageNum <= 1) {
		                left = 1
		                right = 3
		            } else {
		                right = this.totalPage
		                left = this.totalPage - 2
		            }
		        }
		    }
		    while (left <= right) {
		        ar.push(left)
		        left++
		    }
		    this.indexs = ar
		
		},
		goPage(type) {
		    if (type == 'home') {
		        this.pageNum = 1
		    } else if (type == 'end') {
		        this.pageNum = Number(this.totalPage)
		
		    } else if (type == 'last') {
		        if (this.pageNum > 1) {
		            this.pageNum = this.pageNum - 1
		        }
		    } else if (type == 'next') {
		        if (this.pageNum < (this.totalPage)) {
		            this.pageNum = this.pageNum + 1
		        }
		    } else {
		        this.pageNum = type
		    }
		    this.getData()
		},
		getData(){
			let par={
				region:this.region,
				pageNumber: this.pageNum,
				client:this.client,
				pageSize: 25,
				
			}
			getClientList(par).then(res => {
			  this.list = res.data.list;
			  this.totalPage = Math.ceil(res.data.totalRow / 25)
			  this.checkIndex();
			});
		}
     
  	}
  }
</script>

<style scoped>
	.banner{
		background-image: url('../../assets/images/banner_05.png');
	}


</style>
